import React from 'react'

const QuizSubmissionContext = React.createContext({
  quizSubmission: '',
  setQuizSubmisison: () => {},
})

export default QuizSubmissionContext
